import { IAllStatusInclAll, IShippingStatus } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { Container } from '@/components/Container';
import { SettingsContext } from '@/contexts/SettingsContext';

interface IStatusIconProps {
  status: IAllStatusInclAll;
  statusType: 'STATUS';
  size?: number;
}

interface IShippingStatusIconProps {
  status: IShippingStatus;
  statusType: 'SHIPPING_STATUS';
  size?: number;
}

const DEFEAULT_SIZE = 32;

const statusIconMapping: Record<IAllStatusInclAll, string> = {
  ALL_OPEN_ORDERS: '/icons/statusIcons/status_ALL_OPEN_ORDERS.png',
  ALL_OPEN_PREORDERS: '/icons/statusIcons/status_ALL_OPEN_PREORDERS.png',
  ALL_ORDERS: '/icons/statusIcons/status_ALL_ORDERS.png',
  ALL_PREORDERS: '/icons/statusIcons/status_ALL_PREORDERS.png',
  BEING_PREPARED: '/icons/statusIcons/status_BEING_PREPARED.png',
  DELIVERED: '/icons/statusIcons/status_DELIVERED.png',
  FLAWED: '/icons/statusIcons/status_FLAWED.png',
  INTERNAL_ORDER_COMPLETED: '/icons/statusIcons/status_INTERNAL_ORDER_COMPLETED.png',
  NEW: '/icons/statusIcons/status_NEW.png',
  DECLINED: '/icons/statusIcons/status_DECLINED.png',
  PREORDER: '/icons/statusIcons/status_PREORDER.png',
  PREORDER_COMPLETED: '/icons/statusIcons/status_PREORDER_COMPLETED.png',
  SHIPPED: '/icons/statusIcons/status_SHIPPED.png',
};

const shippingStatusIconMapping: Record<IShippingStatus, string> = {
  CANCELLED: '/icons/shippingStatusIcons/shippingStatus_CANCELLED.png',
  DELAYED: '/icons/shippingStatusIcons/shippingStatus_DELAYED.png',
  FAILED_ATTEMPT: '/icons/shippingStatusIcons/shippingStatus_FAILED_ATTEMPT.png',
  IN_TRANSIT: '/icons/shippingStatusIcons/shippingStatus_IN_TRANSIT.png',
  LABEL_CREATED: '/icons/shippingStatusIcons/shippingStatus_LABEL_CREATED.png',
  OUT_FOR_DELIVERY: '/icons/shippingStatusIcons/shippingStatus_OUT_FOR_DELIVERY.png',
  RETURNED: '/icons/shippingStatusIcons/shippingStatus_RETURNED.png',
  UNABLE_TO_DELIVER: '/icons/shippingStatusIcons/shippingStatus_UNABLE_TO_DELIVER.png',
};

export const StatusIcon = ({
  size = DEFEAULT_SIZE,
  status,
  statusType,
}: IStatusIconProps | IShippingStatusIconProps) => {
  const { settings } = useContext(SettingsContext);
  const statusCategoryMapping = settings?.statusCategoryMapping;

  if (!statusCategoryMapping) {
    return null;
  }

  const iconPath = statusType === 'STATUS' ? statusIconMapping[status] : shippingStatusIconMapping[status];

  if (!iconPath) {
    return null;
  }

  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <img
        src={iconPath || '/icons/shippingStatusIcons/shippingStatus_BEING_PREPARED.png'}
        width={size}
        height={size}
      />
    </Container>
  );
};
